<template>
  <div id="app">
    <div class="bar">
      <div style="flex: 1;max-width: 1300px;margin: 0 auto; display: flex;box-sizing:border-box;align-items: center;">
        <div style="text-align:left;align-items:center;cursor: pointer;margin-right: 5%;">
          <img src="./assets/logo_new.png" style="height:30px;" @click="gotoS4Syun"/>
        </div>
        <div class="tabs">
          <span @click="gotoS4Syun">首页</span>
          <span :class="{select: $route.path === '/'  || $route.path === '/ticketPay'}" @click="goToPage('/')">违章查询处理</span>
          <span :class="{select: $route.path === '/pay' || $route.path === '/paying'}" @click="goToPage('/pay')">现场单缴罚</span>
          <span :class="{select: $route.path === '/order'}" @click="goToPage('/order')">我的订单</span>
          <span v-if="Tel" @click="outLogin" style="font-size:14px;color:#fff;">
            <i class="el-icon-mobile-phone"/>
            {{Tel}}
          </span>
          <el-button class="login-btn" v-if="!Tel" @click="openLogin">登录</el-button>
        </div>
      </div>
    </div>
    <div style="width:100%;position: relative" :style="showbanner ? 'display: block;' : 'display: none;'">
      <img @click="gotoMovecar" src="https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/img/vio_banner_tmall.jpg" style="width:100%;;cursor: pointer;display: block">
      <img @click="showbanner = false" src="./assets/close.png" style="width: 40px;height: 40px; position: absolute;right: 75px;top: 50%;margin-top: -20px;">
    </div>
    <a ref="banner" href="https://detail.tmall.com/item.htm?spm=a220m.1000858.1000725.21.67065fe12Hp3qY&id=568820639768&areaId=330100&user_id=3854958416&cat_id=2&is_b=1&rn=8dc3685735df4ec921fa3ad0ccb6f879" style="disable:none;"></a>
    <div>
      <router-view @getLogin="getLogin"></router-view>
    </div>
    <!-- <img src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <div class="qcds">
      本服务由<span @click="gotoS4Syun" style="text-decoration: underline;">齐车大圣</span>提供，客服电话：<span @click="phoneCall" style="text-decoration: underline;">400-000-1199</span>
    </div>
    <login v-model="showLogin" @callback="getLogin"></login>
    <div class="notice" v-if="showNotice" :style="showNotice?'top: 0':'top: -80rpx'">
      <div class="notice-content" v-if="noticeData" @click="handleTapNotice">
        <div class="notice-text">
          {{noticeData.Title}}：{{noticeData.Alert}}
          <!-- 大三季度卡速度快: 阿昆达开始打卡阿夫林萨姆法拉盛麻烦了什么懒驴上磨法拉盛免费辣么发来撒米立方米爱发明了;澳门了;上面拉什么了发放 -->
        </div>
      </div>
      <div class="notice-close" @click="handleCloseNotice">
        <img src="https://app.s4s.cn/razio/close.png" mode="widthFix" style="width:15px;height:15px;" />
      </div>
    </div>
  </div>
</template>

<script>
import login from './components/component/Login.vue'
export default {
  components: {
    'login': login
  },
  mounted(){
    _czc.push(['_trackEvent', 'channel', 'form', this.$route.query.channel + '','1','']); //eslint-disable-line
    // var h=window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    //   document.body.style.height = h+"px";
    const self = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        self.screenWidth = window.screenWidth
      })()
    }
    if(this.screenWidth <= 710) {
      let carno = this.$route.query.carno ? 'carno=' + this.$route.query.carno : ''
      let vin = this.$route.query.vin ? '&vin=' + this.$route.query.vin : ''
      let engine = this.$route.query.engine ? '&engine=' + this.$route.query.engine : ''
      let car_type = this.$route.query.car_type ? '&car_type=' + this.$route.query.car_type : ''
      let channel = this.$route.query.channel ? '&channel=' + this.$route.query.channel : ''
      let url = 'https://mys4s.cn/static/vio/index.html#/'
      if(window.localStorage.grey) {
        url = 'https://mys4s.cn/grey/static/vio/index.html#/'
      }
      window.location.href = carno ? url + '?' + carno + vin + engine + car_type + channel : url
    }
    this.getCommonNotice()
  },
  data(){
    return {
      activeName: 'first',
      showLogin:false,
      Tel: window.localStorage.UserTel,
      screenWidth: document.body.clientWidth,
      showbanner: true,
      noticeData:null,
      showNotice: false,
    }
  },
  watch:{
    screenWidth (val) {
				this.screenWidth = val
				if(this.screenWidth <= 710) {
					let carno = this.$route.query.carno ? 'carno=' + this.$route.query.carno : ''
					let vin = this.$route.query.vin ? '&vin=' + this.$route.query.vin : ''
					let engine = this.$route.query.engine ? '&engine=' + this.$route.query.engine : ''
					let car_type = this.$route.query.car_type ? '&car_type=' + this.$route.query.car_type : ''
					let channel = this.$route.query.channel ? '&channel=' + this.$route.query.channel : ''
					let url = 'https://mys4s.cn/static/vio/index.html#/'
					if(window.localStorage.grey) {
						url = 'https://mys4s.cn/grey/static/vio/index.html#/'
					}
					window.location.href = carno ? url + '?' + carno + vin + engine + car_type + channel : url
				}
				
			}
  },
  methods:{
    handleTapNotice() {
      if(this.noticeData.Type===1){
        //h5
        window.location.href = this.noticeData.Link
      }else if(this.noticeData.Type===2){
        //xiaochengxu
        // my.navigateToMiniProgram({
        //   appId: this.data.noticeData.Link + '',
        // })
      }else if(this.noticeData.Type===3){
        //tanchuang
        this.$alert(this.data.noticeData.Alert, this.data.noticeData.Title, {
            confirmButtonText: '我知道了',
            callback: () => {
                
            }
        });
      }
    
    },
    handleCloseNotice() {
        this.showNotice = false
    },
    getCommonNotice() {
      this.$request('v5/notify/query',{
        app:'vio',
        channel:'pc',
      }).then((xhr, res)=>{
        if(res.code===0&&res.data){
          res.data.forEach(item=>{
            if(item.Tab == 'index'&&item.Notify&&item.Notify.Alert&&item.Notify.Title){
              setTimeout(()=>{
                  this.noticeData = item.Notify,
                  this.showNotice = true
              },2000)
            }
          })
        }
      })
    },
    gotoMovecar() {
      _czc.push(["_trackEvent", "点击", "进入天猫"]);//eslint-disable-line
      console.log('gotoMovecar')//eslint-disable-line
      this.$refs.banner.click();
    },
    goToPage(path) {
      if (path === '/'){
        this.$router.push({
          path: '/',
        })
      } else if(path == '/order'){
        if(!window.localStorage.UserTel){
          this.showLogin = true
          return
        }
        this.$router.push({
          path: path,
        })
      } else {
          this.$store.state.orderNumber = ''
          this.$store.state.handFill = {
              nick: '',
              nickCarNo:'',
              date:'',
              ticketUrl: '',
              price: '',
              ownFree: 0,
              lateFree:  0,
              showForm1: false,
              showForm2: false,
              showNotice: true,
              drive_no: false,
          }
        this.$router.push({
          path: path,
        })
      }
    },
    openLogin(){
      this.showLogin = true
    },
    getLogin(){
      this.Tel = window.localStorage.UserTel
    },
    outLogin(){
      this.$confirm('确定退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        window.localStorage.UserTelAll = ''
        window.localStorage.UserId = ''
        window.localStorage.UserTel = ''
        window.localStorage.UserIcon = ''
        window.localStorage.UserName = ''
        window.localStorage.AccessToken = ''
        window.localStorage.historyVioList = []
        this.Tel = ''
        this.$router.replace({
          path: '/',
        })
        this.$message({
          type: 'success',
          message: '退出登录成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });          
      });
    },
    gotoS4Syun(){
      window.open('https://mys4s.cn/#/driver?current=1')
    },
    phoneCall(){
      window.location.href = "tel://400-000-1199"
    }
  }
}
</script>

<style>
html{
  height: 100%;
}
body{
  padding-top:80px;
  height:100%;
  box-sizing: border-box;
  background: #F3F6FA;
  overflow-x: auto;
  /* background: url(https://s4s-app.oss-cn-hangzhou.aliyuncs.com/shoptest/static/img/login-wrap.png) no-repeat; 
  background-size:100% 100%;
  background-attachment: fixed;*/
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  color: #2c3e50;
}
.container {
  /* background: #fff; */
  width:100%;
  overflow-x:auto;
  display: flex;
}
.content{
  margin: 30px auto 50px;
  max-width: 1300px;
  flex: 1;
}
*{
  margin: 0;
  box-sizing: border-box;
}
.bar{
  background-image: linear-gradient(-225deg, #0076FF 0%, #0064FF 100%);
  height: 80px;
  position: fixed;
  top: 0;
  width: 100%;
  display: flex;
  box-sizing:border-box;
  align-items: center;
  margin: 0 auto;
  z-index: 100;
}
.bar .tabs>span{
  padding: 0 15px;
  line-height: 80px;
  height:80px;
  display: inline-block;
  box-sizing:border-box;
  cursor: pointer;
  font-size:16px;
  font-weight: 400;
}
.tabs{
  color: #fff;
}
.bar .tabs .login-btn{
  width: 110px;
  height: 40px;
  padding: 0;
  position: absolute;
  right: 18%;
  top: 20px;
  color: #0067FF;
}


.select{
  color:#fff;
  background:  #005FE3;
}
.el-message{
  top: 70px !important;
}
.qcds{
  width: 100%;
  text-align: center;
  font-size: 14px;
  margin: 55px 0;
  color: #9DA9B9;
}
.qcds span{
  color: #002257;
  cursor: pointer;
}
.icon-class{
    width: 21px;
    height: 21px;
    margin: 0 5px 5px;
}

.app-download{
    width: 266px;
    background: #fff;
    position: absolute;
    top: 80px;
    right: 0;
    text-align:center;
    padding-top: 20px;
}
.imgfont{
    height: 90px;
    position: absolute;
    right: 0;
    top: -10px;
    display: none;
}
.attention-important {
  background: #F8E5CD;
  font-size: 14px;
  color: #E89102;
  display: flex;
  /* line-height: 3.5; */
  align-items: center;
  padding-left: 15px;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
}

.notice {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(255, 237, 151);
  font-size: 15px;
  display: flex;
  white-space: nowrap;
  z-index: 999;
  z-index: 99999;
  transition: top 1800ms;
  padding-left: 15px;
}
.notice-content {
  overflow: hidden;
  width: 100%;
  padding: 10px 0;
}
.notice-text {
  color: rgb(97, 92, 68);
  line-height: 1;
  position: relative;
  width: 100%;
  /* animation:notice 20s linear infinite; */
}
.notice-close {
  line-height: 1;
  padding: 10px 15px;
  display: flex;
  align-items: center;
}
</style>
